import PillButton from "components/General/PillButton";

export default function PillSelectorMenu({
  title="",
  options=[],
  selectedOption=0,
  setSelectedOption=(e:number) => null,
} : {
  title?: string,
  options?: Array<any>,
  selectedOption?: number,
  setSelectedOption?: (e: number) => void,
}) {
  return (
    <div className="flex flex-col gap-2">
      {title !== "" && (
        <label className="text-center">{title}</label>
      )}
      { options.map((e, i) => {
        return (
          <PillButton
            key={i}
            text={e}
            selected={i === selectedOption}
            onClick={() => {
              setSelectedOption(i)
            }}
          />
        )
      })}
    </div>
  )
}
